
import { IconPlus, RevModal } from '@backmarket/design-system'

import { MODAL_NAMES } from '@config/constants'

import { VARIANTS as BUNDLE_ADD_TO_CART_VARIANTS } from '../../BundleAddToCart/BundleAddToCart.constants'
import BundleAddToCart from '../../BundleAddToCart/BundleAddToCart.vue'
import BundleListing from '../../BundleListing/BundleListing.vue'

import translations from './BundleModal.translations'

export default {
  components: {
    RevModal,
    BundleAddToCart,
    BundleListing,
    IconPlus,
  },

  props: {
    status: {
      type: String,
      required: true,
    },
    listings: {
      type: Array,
      default: () => [],
    },
    totalPrice: {
      type: String,
      default: null,
    },
  },
  computed: {
    BUNDLE_ADD_TO_CART_VARIANTS: () => BUNDLE_ADD_TO_CART_VARIANTS,
    translations: () => translations,
    name: () => MODAL_NAMES.PRODUCT.BUNDLE,
  },

  methods: {
    addToCart() {
      this.$emit('add-to-cart')
    },
  },
}
